<template>
  <DeadliestSoap />
  <MurderMethods />
  <BiggestKillers />
  <DeadliestYear />
  <Methodology headerColour="red" />
</template>

<script>
import DeadliestSoap from "@/components/MurderViewSection/DeadliestSoap/DeadliestSoap";
import BiggestKillers from "@/components/MurderViewSection/BiggestKillers/BiggestKillers";
import MurderMethods from "@/components/MurderViewSection/MurderMethods/MurderMethods";
import DeadliestYear from "@/components/MurderViewSection/DeadliestYear/DeadliestYear";
import Methodology from "@/components/MethodSection/Methodology";

export default {
  components: {
    DeadliestSoap,
    BiggestKillers,
    MurderMethods,
    DeadliestYear,
    Methodology,
  },
};
</script>

<style lang="scss" scoped></style>
